<template>
    <v-btn
        class="mx-1 w35 h35"
        fab
        depressed
        :color="connectionStatus"
        :class="{ blinking: connectionStatus !== 'success' }"
        @click="emitter.$emit('show-connection-management')"
    >
        <v-icon v-if="connectionStatus === 'error'" size="18px">fas fa-wifi-slash</v-icon>
        <v-icon v-else-if="connectionStatus === 'warning'" size="18px">fas fa-wifi</v-icon>
        <v-icon v-else size="18px">fas fa-wifi</v-icon>
    </v-btn>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAppStore } from '@/store/useAppStore';
import Terminal from '@/models/Terminal';

const store = useAppStore();
const emitter = EventBus

const terminals = ref([])
const terminal = ref()
const isWeb = computed(() => store.getters.device?.platform === 'web')

onMounted(async () => {
    terminals.value = Terminal.all()
    terminal.value = await Terminal.current()
})

const showLocalConnection = computed(() => !isWeb.value && !!terminal.value && terminals.value.some(t => t.isKitchenDisplaySystem()))
const hasConnectedTerminals = computed(() => store.getters.localConnection.terminals.filter(t => t.connected).length > 1)
const connectionsStatus = computed(() => {
    return {
        internet: store.getters.isOnline ? 'success' : 'error',
        local: !store.getters.localConnection.connected ? 'error' : (store.getters.localConnection.isServer && !hasConnectedTerminals.value ? 'warning' : 'success')
    }
})

const connectionStatus = computed(() => {
    const { local, internet } = connectionsStatus.value
    if(!showLocalConnection.value) return internet

    if(internet === 'success' && local === 'success') return 'success'
    else if(internet === 'success') return 'warning'

    return 'error'
})
</script>

<style lang="scss" scoped>
.blinking {
  animation: blink 1.2s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>
